// Select de Opción 2 (Tipificación) escopado por pipeline. El Select compartido
// de FormControls no soporta <optgroup>, y `alta_poliza` tiene DOS grupos (Altas
// Nuevas + Portabilidad) que deben pintarse como optgroups de un mismo select
// (decisión 2026-07-16 del CRM). Este componente replica ese render.
//
// El llamante decide si mostrarlo: solo tiene sentido cuando
// `typificationsForPipeline(pipeline)` no está vacío.

import { inputStyle } from "../FormControls";
import { TicketTypificationGroup } from "../../api/crmTicketTypification";

export function TypificationSelect({
  value,
  onChange,
  groups,
  disabled,
  placeholder = "—",
}: {
  value: string;
  onChange: (v: string) => void;
  groups: readonly TicketTypificationGroup[];
  disabled?: boolean;
  placeholder?: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{ ...inputStyle, appearance: "auto" }}
    >
      <option value="">{placeholder}</option>
      {groups.length > 1
        ? groups.map((g) => (
            <optgroup key={g.hubspotProperty} label={g.label}>
              {g.options.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </optgroup>
          ))
        : (groups[0]?.options ?? []).map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
    </select>
  );
}
